import { useEffect, useState } from "react";

/**
 * React hook that triggers sort on array only if isSortingRequired is true
 * @param sourceItems - an array of items that would be sorted if isSortingRequired is true
 * @param isSortingRequired - set true to make items sorted
 * @param comparer - an optional comparer of items. Do not forget to use useCallback for the comparer function
 * @returns an array, either sorted or original depending on isSortingRequired parameter
 */
export const useDeferredSort = <T>(sourceItems: T[], isSortingRequired: boolean, comparer?: (x: T, y: T) => number) => {
    const [items, setItems] = useState<T[]>([]);

    useEffect(() => {
        const current = [...sourceItems];

        if (isSortingRequired) {
            current.sort(comparer);
        }

        setItems(current);
    }, [sourceItems, isSortingRequired, comparer]);

    return items;
};
